import React from "react";
import Hero from "@/components/sections/Hero";
import MarqueeBand from "@/components/MarqueeBand";
import Pillars from "@/components/sections/Pillars";
import ProofBar from "@/components/sections/ProofBar";
import FeaturedWork from "@/components/sections/FeaturedWork";
import Testimonials from "@/components/sections/Testimonials";
import LearnPreview from "@/components/sections/LearnPreview";
import AboutPreview from "@/components/sections/AboutPreview";
import CTABanner from "@/components/sections/CTABanner";

const Home = () => (
    <main data-testid="home-page">
        <Hero />
        <MarqueeBand items={["The studio for founders who plan to be remembered", "Design · Consult · Learn", "Gurgaon & Kuala Lumpur"]} />
        <Pillars />
        <ProofBar />
        <FeaturedWork />
        <Testimonials />
        <LearnPreview />
        <AboutPreview />
        <CTABanner />
    </main>
);

export default Home;
